import type { FeatureToggleKeys } from '@shared/interfaces/refreshed-component';
import { FEATURES } from '@shared/constants/routing-paths.constants';
import { isNotDefined } from '@3dsource/utils';

export const parseBetaFeatures = (data: object) => {
  const remoteFeatures = data as Record<FeatureToggleKeys, boolean>;
  const savedFeatures = localStorage.getItem(FEATURES) ?? '';
  try {
    const parsedFeatures = JSON.parse(savedFeatures) as Record<
      FeatureToggleKeys,
      boolean
    >;
    return Object.keys(remoteFeatures).reduce(
      (acc, key) => {
        const featureKey = key as FeatureToggleKeys;
        const localValue = parsedFeatures[featureKey];

        acc[featureKey] = isNotDefined(localValue)
          ? remoteFeatures[featureKey]
          : localValue;
        return acc;
      },
      {} as Record<FeatureToggleKeys, boolean>,
    );
  } catch {
    localStorage.setItem(FEATURES, JSON.stringify(remoteFeatures));
    return remoteFeatures;
  }
};
